var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

var trackingHandler = {

    /**
     * If map for a page was already set
     *
     * @param {Boolean} mapSet
     */
    mapSet: false,

    /**
     * Set map for a page to operate during fireEvent
     *
     * @param {Object} map
     */
    useMap: function useMap(map) {
        if (this.mapSet) {
            return;
        }

        // Map should be object
        if (!map || typeof map !== 'object') {
            throw new Error('Tracking map should be object');
        }

        this.map = map;
        this.mapSet = true;
    },

    /**
     * Fire specific event from current page map
     *
     * @param {String} id - id of event to search by
     * @param {Object} overrides - object to override default properties for event
     * @param {Object} options - options to pass to event-functions
     */
    fireEvent: function fireEvent(id, overrides, options) {
        var event = this.map[id];

        // If nothing found in maps
        if (!event) {
            throw new Error('The tracking event "' + id + '" is not defined');
        }

        // If function, event should be called with options to dynamically add params to event_data if needed
        if (typeof event === 'function') {
            event = event(options);
        }

        // Perform all necessary inherits and fire event
        eventToolbox.fireAction($.extend(true, {}, event, overrides));
    }
};

module.exports = trackingHandler;



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/tracking/handler.js
// module id = 48
// module chunks = 36